import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  CreateInstallmentRequestSchema,
  CreateInstallmentRequestType,
  CreateInstallmentResponseSchema,
  CreateInstallmentResponseType
} from '../../../services/IbInstallmentsServices/APIService/types';

import { useIbInstallmentsService } from '../useIbInstallmentsService';

interface UseCreateInstallmentApiInterface {
  createInstallmentApi: (
    input: CreateInstallmentRequestType
  ) => Promise<CreateInstallmentResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useCreateInstallmentApi = (): UseCreateInstallmentApiInterface => {
  const { ibInstallmentsServiceInstance } = useIbInstallmentsService();

  const createInstallment = (requestObject: CreateInstallmentRequestType) => {
    try {
      // Always validate request object against schema
      CreateInstallmentRequestSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return ibInstallmentsServiceInstance
      .createInstallment(requestObject)
      .then((response) => {
        try {
          // Always validate response against schema
          CreateInstallmentResponseSchema.parse(response);
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
    createInstallment,
    {
      mutationKey: ['createInstallmentApi']
    }
  );

  return {
    createInstallmentApi: mutateAsync,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    reset
  };
};

export { useCreateInstallmentApi };
